import BaseBehavior from '../../../framework/base/base';
import { debounce } from '../../../shared/utilities/debounce';

export default class AdjustGridItemHeight extends BaseBehavior {
	constructor(element) {
		super(element);
		this.products = Array.from(element.querySelectorAll('.v2-col'));
		this.adjustHeight();
		this.addListener();
	}

	adjustHeight() {
		const productHeights = this.products.map(item => item.clientHeight);
		const maxHeight = Math.max(...productHeights);
		this.products.forEach(item => {
			item.style.height = `${maxHeight}px`;
		});
	}

	addListener() {
		const debouncedResizeHandler = debounce(() => {
			this.products.forEach(item => {
				item.style.height = `auto`;
			});
			this.adjustHeight();
		}, 100);

		this.addEventListener(window, 'resize', debouncedResizeHandler);
	}

	cleanup() {
		this.removeEventListener(window, 'resize');
	}
}
